import request from '@/util/http.js'
//考勤设置
export const attendanceSettings = () => {
  return request({
    url: '/attendance/attendanceSettings',
    method: 'get',
  })
}
// 添加规则
export const addRule = (data) => {
  return request({
    url: '/attendance/addRule',
    method: 'post',
    data
  })
}
// 编辑规则
export const editRule = (data) => {
  return request({
    url: '/attendance/editRule',
    method: 'post',
    data
  })
}
// 删除规则
export const delRule = (data) => {
  return request({
    url: '/attendance/delRule',
    method: 'delete',
    data: data
  })
}
